import react from "react";

function Divider(){
    return(
        <div style={{width: '80%',margin: '40px auto', borderTop: '1px solid #f4ff9e'}}></div>
    );
}

export default Divider